import {
  Button,
  Div,
  H3,
  Modal,
  P,
  requestRefund,
  reportError,
} from '@vgrubs/components';
import { Dispatch, SetStateAction } from 'react';

export const DeliveriesRequestRefund = ({
  isOpen,
  setIsOpen,
  setLoading,
  id,
}: {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  setLoading: Dispatch<SetStateAction<boolean>>;
  id: string;
}) => {
  async function handleRefund() {
    try {
      setLoading(true);
      const { data } = await requestRefund(id);
      window.open(data.data, '_blank', 'noopener,noreferrer');
      setIsOpen(false);
      setLoading(false);
    } catch (error) {
      reportError(error);
      setLoading(false);
    }
  }

  return (
    <Modal
      isOpen={isOpen}
      closeModal={() => {
        setIsOpen(false);
      }}
      logo={false}
      exitButton={false}
    >
      <H3 $m="10px" $center>
        Request Refund
      </H3>
      <P $mb="24" $center>
        Are you sure you want to request a refund?
      </P>

      <Div $flex $gap="16px">
        <Button onClick={handleRefund} $w="100%" $selected>
          Yes
        </Button>
        <Button $w="100%" onClick={() => setIsOpen(false)} $gray $selected>
          No
        </Button>
      </Div>
    </Modal>
  );
};
